import "./LearningPathCurriculum.module.css";
import Header from "@/reusable_sections/Header";
import Journey from "./sections/Journey";
import Curriculum from "./sections/Curriculum";
import Milestones from "./sections/Milestones";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
import CurriculumProgression from "./sections/CurriculumProgression";
export default function LearningPathCurriculumPage() {
  return <div>
      <Header />
      <Journey />
      <CurriculumProgression />
      <Curriculum />
      <Milestones />
      <Consultation />
      <Footer />
    </div>;
}